const autoNgTemplateLoaderTemplate1 = require('./azureEndpointConfig.html');

angular.module('shbdeployer.azure').component('azureEndpointConfig', {
  bindings: {
    applicationId: '=',
    tenantId: '=',
    authenticationKey: '=',
  },
  templateUrl: autoNgTemplateLoaderTemplate1,
});
